var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersovitesse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3105 84.5625H82.5884C87.0333 84.5625 91.1953 82.3818 93.7255 78.7272L110.859 53.978C112.024 52.2955 112.179 50.1124 111.264 48.2823C109.508 44.7692 104.776 44.1064 102.121 47.0018L88.5205 61.8388C83.0532 67.8038 74.4647 69.7615 66.9525 66.7567L48.3802 59.328C43.759 57.4794 38.524 58.0242 34.3827 60.7851L14.7189 73.8943C12.1648 75.5973 11.2783 78.9353 12.6511 81.6807C14.1544 84.6876 17.8105 85.9063 20.8172 84.4031L37.1425 76.2405C40.3225 74.6502 43.795 77.8031 42.5188 81.1216L33.3106 105.062M35.8731 20.5H20.4981M30.7481 35.875H20.4981M92.248 33.3125C92.248 44.6343 83.0701 53.8125 71.748 53.8125C60.4263 53.8125 51.248 44.6343 51.248 33.3125C51.248 21.9907 60.4263 12.8125 71.748 12.8125C83.0701 12.8125 92.248 21.9907 92.248 33.3125Z",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersovitesse);
export default __webpack_public_path__ + "static/media/persovitesse.83ba363043e32a9cce4dd71d8a72df98.svg";
export { ForwardRef as ReactComponent };